import { render } from "./FunFor.vue?vue&type=template&id=0b34f88c"
import script from "./FunFor.vue?vue&type=script&lang=js"
export * from "./FunFor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__